import {
  SelectionCard,
  SelectionCardActions,
  SelectionCardContent,
  SelectionCardIcon,
  SelectionCardText,
  SelectionCardTitle,
} from '@components/SelectionCard';
import { datadogRum } from '@datadog/browser-rum';
import { Box } from '@spark-web/box';
import { CheckIcon, DocumentAddIcon } from '@spark-web/icon';
import { Inline } from '@spark-web/inline';
import { Stack } from '@spark-web/stack';
import { INCOME_VERIFICATION } from '@utils';

interface SelfDeclaredIncomeProps {
  onUseManualIncome: () => void;
  useOccupationGate?: boolean;
}

function SelfDeclaredIncome({ onUseManualIncome, useOccupationGate }: SelfDeclaredIncomeProps) {
  const {
    MANUAL_INPUT_TITLE,
    MANUAL_INPUT_TITLE_UPLOAD_INCOME_DOCUMENTS,
    MANUAL_INPUT_DESCRIPTION,
    MANUAL_INPUT_DESCRIPTION_OCCUPATION_GATE,
    MANUAL_INPUT_ACTION,
    MANUAL_INPUT_ACTION_UPLOAD_DOCUMENTS,
  } = INCOME_VERIFICATION;
  const title = useOccupationGate ? MANUAL_INPUT_TITLE_UPLOAD_INCOME_DOCUMENTS : MANUAL_INPUT_TITLE;
  const description = useOccupationGate ? MANUAL_INPUT_DESCRIPTION_OCCUPATION_GATE : MANUAL_INPUT_DESCRIPTION;
  const actionLabel = useOccupationGate ? MANUAL_INPUT_ACTION_UPLOAD_DOCUMENTS : MANUAL_INPUT_ACTION;
  const onClick = () => {
    datadogRum.addAction('User selected manual income verification');
    onUseManualIncome();
  };

  return (
    <SelectionCard
      border="standard"
      borderWidth="standard"
      borderRadius="medium"
      padding="large"
      display="flex"
      flexDirection="column"
      gap="medium"
    >
      <Box
        alignItems="center"
        gap="small"
        borderRadius="medium"
        background="inputPressed"
        paddingX="large"
        paddingY="medium"
        display="inline-flex"
      >
        <DocumentAddIcon size="xsmall" />
      </Box>
      <Stack gap="small" width="full" marginTop="medium" flex={1}>
        <SelectionCardContent marginTop="medium">
          <SelectionCardTitle size="large">{title}</SelectionCardTitle>
          <Stack gap="medium">
            {description.map((desc, index) => (
              <Box gap="small" display="flex" alignItems="center" key={index}>
                <Box display="flex" justifyContent="center" alignItems="center">
                  <CheckIcon tone="primary" size="xsmall" />
                </Box>
                <SelectionCardText>{desc}</SelectionCardText>
              </Box>
            ))}
          </Stack>
          <Box gap="xlarge" display="flex" alignItems="center" css={{ marginTop: 'auto' }}>
            <Inline gap="xlarge" alignY="center" width={{ mobile: 'full', tablet: 'none' }}>
              <SelectionCardActions
                tone="neutral"
                prominence="high"
                onClick={onClick}
                data={{ testid: 'input-manual-btn' }}
                css={{ width: '100%', '@media (min-width: 740px)': { width: 'auto' } }}
              >
                {actionLabel}
              </SelectionCardActions>
            </Inline>
          </Box>
        </SelectionCardContent>
      </Stack>
    </SelectionCard>
  );
}

export default SelfDeclaredIncome;
